import React from "react";
import { default as AntdIcon } from "@ant-design/icons";

const Icon = ({ icon, style = {}, theme, twoToneColor }) => {
  const isCustomSvgIcon = typeof icon === "function";
  if (isCustomSvgIcon) {
    return icon();
  }
  const isAntdIcon = typeof icon === "string";
  if (isAntdIcon) {
    return <AntdIcon component={icon} style={style} />;
  }

  return (
    <AntdIcon
      component={icon}
      style={style}
      theme={theme}
      twoToneColor={twoToneColor}
    />
  );
};

export default Icon;
